/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const AdminUserGet = {
  id: 'admin-user.get',
  tag: 'Admin',
  summary: 'Get Users',
  description: 'Get all the users',
  method: 'get',
  flags: { isAuthorized: true, isSuperuser: true },
  route: () => `/administration/user`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              id: ZodTypes.Id,
              email: z.string().email(),
              firstName: z.string().min(1),
              middleName: z.string().min(1).nullable().optional(),
              lastName: z.string().min(1),
              verified: z.boolean(),
              phoneNationalNumber: z.string().min(1).nullable().optional(),
              phoneCountryCode: ZodTypes.Country.nullable().optional(),
              language: ZodTypes.Language,
              isSuperuser: z.boolean(),
              isDisabled: z.boolean(),
              ratingLevel: z.string().nullable().optional(),
              marketable: z.boolean().nullable(),
              passwordChangeToken: z
                .object({
                  userId: ZodTypes.Id.optional(),
                })
                .nullable()
                .optional(),
              organizations: z
                .strictObject({
                  id: ZodTypes.Id,
                  role: ZodTypes.RBAC.Organization.Roles,
                  organization: z.any(),
                  user: z
                    .strictObject({
                      id: ZodTypes.Id,
                      email: z.string().email(),
                      firstName: z.string().min(1),
                      middleName: z.string().min(1).nullable().optional(),
                      lastName: z.string().min(1),
                      verified: z.boolean(),
                      phoneNationalNumber: z.string().min(1).nullable().optional(),
                      phoneCountryCode: ZodTypes.Country.nullable().optional(),
                      language: ZodTypes.Language,
                    })
                    .nullable()
                    .optional(),
                })
                .array()
                .optional(),
              invitations: z
                .strictObject({
                  id: ZodTypes.Id,
                  email: z.string().email().nullable().optional(),
                  firstName: z.string().min(1).nullable().optional(),
                  middleName: z.string().min(1).nullable().optional(),
                  lastName: z.string().min(1).nullable().optional(),
                  organization: z.any(),
                })
                .array()
                .optional(),
              address: z
                .strictObject({
                  id: ZodTypes.Id,
                  line1: z.string().min(1),
                  line2: z.string().optional().nullable(),
                  line3: z.string().optional().nullable(),
                  postalCode: z.string().min(1),
                  city: z.string().min(1),
                  state: z.string().optional().nullable(),
                  countryCode: ZodTypes.Country,
                })
                .nullable()
                .optional(),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
